import React from "react";
import { Box, Typography } from "@mui/joy";
import { theme } from "styles/theme";

// =========================
// PresetScenarios — clickable bubbles to send canned messages
// =========================

export interface PresetScenario {
  id: string;
  label: string;
  message: string;
  description?: string;
}

const RAW_TEXT_REVIEW_ALL = `지금까지 만들어진 모든 세트의 활동지를 참고해서, 전체 내용을 한 번에 복습하는 활동지 하나 만들어줘.

먼저 그동안 만든 활동지들을 쭉 살펴보고, 각 세트에서 핵심이 되는 개념과 연습을 골라줘. 그걸 처음부터 지금까지의 흐름이 자연스럽게 이어지도록 엮어서, 전체 거리두기 활동을 되짚는 복습 활동지로 구성해줘. 한 활동지에 모든 걸 욱여넣기보다, 꼭 다시 떠올리면 좋은 핵심 위주로 추려줘.

중간중간 이해를 확인하는 퀴즈를 적절히 넣고, 마지막은 지금까지의 변화를 스스로 돌아보며 정리하는 안내로 마무리해줘.`;

export const PRESET_SCENARIOS: PresetScenario[] = [
  {
    id: "reviewAllTasks",
    label: "모든 활동을 종합한 '총정리 활동지'를 만들어줘",
    message: RAW_TEXT_REVIEW_ALL,
    description:
      "모든 활동지를 종합해 전체 내용을 복습하는 활동지를 만들어달라고 요청",
  },
  {
    id: "addQuiz",
    label: "퀴즈 추가해줘",
    message: "맥락에 맞는 자리에 어울리는 퀴즈를 하나 추가해줘",
    description: "활동지 흐름에 맞는 위치·내용으로 퀴즈를 추가해달라고 요청",
  },
  {
    id: "addTextInput",
    label: "텍스트 인풋 추가해줘",
    message: "맥락에 맞는 자리에 어울리는 텍스트 입력 칸을 추가해줘",
    description:
      "활동지 흐름에 맞는 위치·내용으로 텍스트 입력 칸을 추가해달라고 요청",
  },
  {
    id: "addImage",
    label: "이미지 추가해줘",
    message: "맥락에 맞는 자리에 어울리는 이미지를 하나 추가해줘",
    description: "활동지 흐름에 맞는 위치·내용으로 이미지를 추가해달라고 요청",
  },
  {
    id: "validate",
    label: "검수 해줘",
    message: "현재 활동지를 규칙대로 검수해줘",
    description: "현재 활동지를 v2 규칙대로 검수해달라고 요청",
  },
  {
    id: "help",
    label: "도움말",
    message: "도움말",
    description: "Agent 사용법과 역할 안내를 요청",
  },
];

export function PresetScenariosBar({
  onPick,
  disabled,
}: {
  onPick: (scenario: PresetScenario) => void;
  disabled: boolean;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        px: "12px",
        pt: "8px",
        pb: "4px",
      }}
    >
      <Typography
        level="body-xs"
        sx={{
          fontSize: "10px",
          color: theme.vars.palette.Content.Weak,
          alignSelf: "center",
          mr: "2px",
          fontWeight: 600,
          letterSpacing: "0.04em",
          textTransform: "uppercase",
        }}
      >
        시나리오
      </Typography>
      {PRESET_SCENARIOS.map((scenario) => (
        <Box
          key={scenario.id}
          onClick={() => !disabled && onPick(scenario)}
          title={scenario.description}
          sx={{
            px: "10px",
            py: "4px",
            borderRadius: "999px",
            backgroundColor: theme.vars.palette.Background.Level2,
            border: `1px solid ${theme.vars.palette.Border.Weak}`,
            fontSize: "11px",
            fontWeight: 500,
            color: theme.vars.palette.Content.Medium,
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.5 : 1,
            transition: "all 0.15s ease",
            userSelect: "none",
            "&:hover": disabled
              ? {}
              : {
                  backgroundColor: theme.vars.palette.Background.Level1,
                  borderColor: theme.vars.palette.Content.Medium,
                  color: theme.vars.palette.Content.Strong,
                  transform: "translateY(-1px)",
                },
          }}
        >
          {scenario.label}
        </Box>
      ))}
    </Box>
  );
}
